import styled from "styled-components";

const Container = styled.div`
  width: 100%;

  // Header Bar Open and Close
  .header {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: var(--grisClaro2);
    border: 0;
    border-radius: 16px;
    cursor: pointer;
    transition: 0.15s ease;
    overflow: hidden;
  }

  // Header Bar Title
  .header h4 {
    color: var(--verde50);
    font-weight: 600;
    text-align: left;
    margin: 12px;
    text-align: left;
    transition: 0.2s all;
    font-size: 16px;
  }

  .header span {
    color: var(--verde50);
  }

  // Header Bar Hover Image
  .header img {
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  // Text Container
  .texto {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
  }

  // Text
  .texto p {
    width: 100%;
    text-align: left;
    font-size:13px;
    margin: 0px 0px 0px 0px;
    font-weight: 500;
  }

  // Button in text
  .texto a {
    color: var(--azul20) !important;
    cursor: pointer;
    text-decoration: none;
  }

  // Button Icon
  .texto a span {
    margin-left: 5px;
    margin-right: 5px;
  }

  // Tiempo de transicion cuando se abre y se cierra
  .ReactCollapse--collapse {
    transition: height 400ms;
  }
`;

export default Container;